// extracted by mini-css-extract-plugin
export default {"pageFrame":"BasePage_pageFrame__4PbLd","coloredBackground":"BasePage_coloredBackground__hnFJz","pageContainer":"BasePage_pageContainer__w+fK2"};